import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions} from '@angular/material/form-field'
import {provideRouter, withHashLocation} from '@angular/router'
import routes from './app-routes'
import {MAT_CARD_CONFIG, MatCardConfig} from '@angular/material/card'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  ILoginSettings,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../environments/environment'
import {ADMIN_ROLE, HOME_ROUTE_PATH} from './application/data-types'
import localeSv from '@angular/common/locales/sv'
import {registerLocaleData} from '@angular/common'

registerLocaleData(localeSv)

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [ADMIN_ROLE]
}


export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'Välkommen till Certifikattjänsten, för att komma igång måste du logga in med BankID',
        route: ['/', HOME_ROUTE_PATH]
      } as ILoginSettings
    },
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    provideAppInitializer(() => inject(ConfigService).bootstrap()),

    provideRouter(routes, withHashLocation()),
    provideHttpClient(
      withInterceptors([authInterceptor, responseInterceptor])),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline'
      } as MatFormFieldDefaultOptions
    },
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'} as MatCardConfig}
  ]
}

